
export default class Video {

	static getHolderSelectors = () => ['.video-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;

		if (this.#holderElement.classList.contains('lightbox')) {
			const playVideoElement = this.#holderElement.querySelector('.play-video');
			playVideoElement.addEventListener("click", (event)=>{
				event.preventDefault();

				const lightbox = GLightbox({
					elements: [
						{
							'href': playVideoElement.getAttribute('href'),
							'type': 'video',
						}
					],
				});
				lightbox.open();
			});
		}
	}

}
